/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return */
import { sanitize } from '../../utility/sanitize'
import { SearchContext, SearchFilters } from './schemas'

export function setSearchXkeyHeaders(searchContext: SearchContext, res: any) {
  const slugs = searchContext.results?.campsites?.length
    ? searchContext.results.campsites
        .map((cs) => cs.slug)
        .map((slug) => sanitize(slug))
        .join(' ')
    : ''
  if (!slugs) {
    return
  }
  const currentXkey = res.getHeader('xkey')
  const newXkey =
    currentXkey === undefined ? slugs : `${currentXkey.toString()} ${slugs}`
  res.setHeader('xkey', newXkey)
}

export function httpHeadersCache(to: any) {
  const route = to
  const $config = useRuntimeConfig()
  const isPriceRelated = 'arrive' in route.query || 'depart' in route.query
  const cacheTime = isPriceRelated
    ? $config.priceCacheTime
    : $config.nonPriceCacheTime
  const graceTime = isPriceRelated
    ? $config.priceGraceTime
    : $config.nonPriceGraceTime
  return {
    'Cache-Control': `max-age=${cacheTime}, public`,
    Grace: `${graceTime}`,
  }
}

export function areHierarchiesDifferent(
  searchContext: SearchContext,
  searchFilters: SearchFilters,
) {
  return (
    searchContext &&
    searchContext.results &&
    searchFilters.hierarchyPath &&
    searchContext.results.hierarchy &&
    searchContext.results.hierarchy !== searchFilters.hierarchyPath
  )
}

export async function redirectOnMachineRedirecting(
  searchContext: SearchContext,
  fullPath: string,
  nuxtApp: any,
) {
  const hierarchyPath = searchContext.filters.hierarchyPath || ''
  const redirectToPath = searchContext.redirectToPath || ''
  const redirectPath = searchContext.results?.seoRedirect
    ? searchContext.results.seoRedirect
    : fullPath.replace(hierarchyPath, redirectToPath)
  return await nuxtApp?.runWithContext(async () => {
    await navigateTo(redirectPath, { redirectCode: 301 })
  })
}
